<template>
  <ok-modal
    :value="value"
    :title="getTranslatedField(computedAnnouncement, 'name', true) || $t('announcement.announcement')"
    no-close-on-backdrop
    hide-close
    dialog-class="announcement-modal"
    size="lg"
    @change="$emit('input', $event)"
  >
    <template #title>
      <div class="font-weight-bold">
        {{ getTranslatedField(computedAnnouncement, 'name', true) || $t('announcement.announcement') }}
      </div>
    </template>

    <fetching-data-spinner
      :error="error"
      :loading="loading"
    />

    <div v-if="!loading">
      <div
        v-if="getTranslatedField(computedAnnouncement, 'description', true)"
        class="mb-1"
      >
        {{ getTranslatedField(computedAnnouncement, 'description', true) }}
      </div>
      <div
        v-if="getTranslatedField(computedAnnouncement, 'media_url', true)"
        class="mb-1 announcement-media-container"
      >
        <img
          v-if="computedAnnouncement.media_type === 'image'"
          :src="getTranslatedField(computedAnnouncement, 'media_url', true)"
          class="img-fluid"
          alt="Description Image"
        >
        <ok-video-player
          v-else-if="computedAnnouncement.media_type === 'video'"
          class="announcement-video"
          autoplay
          loop
          :src="getTranslatedField(computedAnnouncement, 'media_url', true)"
        />
      </div>
      <div
        class="d-flex mt-2"
        :class="computedAnnouncement.url ? 'justify-content-between': 'justify-content-center'"
      >
        <b-button
          :class="{'mr-1': !!computedAnnouncement.url }"
          :variant="computedAnnouncement.url ? 'outline-primary' : 'primary'"
          :block="!!computedAnnouncement.url"
          :disabled="dismissing || accepting"
          @click="handleClose(true)"
        >
          <b-spinner
            v-if="dismissing"
            small
          />
          {{ $t('announcement.thanks-close') }}
        </b-button>
        <b-button
          v-if="computedAnnouncement.url"
          variant="primary"
          class="w-100"
          :disabled="accepting || dismissing"
          @click="handleClose(false)"
        >
          <b-spinner
            v-if="accepting"
            small
          />
          {{ getTranslatedField(computedAnnouncement, 'button_title', true) || $t('announcement.check-now') }}
        </b-button>
      </div>
    </div>
  </ok-modal>
</template>

<script>
import { BSpinner, BButton } from 'bootstrap-vue'
import OkModal from '@/@okmenu/components/modals/OkModal'
import AnnouncementsAPI from '@/API/AnnouncementsAPI'
import LocalizationMixin from '@/mixins/localization-mixin'
import OkVideoPlayer from '@/@okmenu/components/media/OkVidePlayer'
import FetchingDataSpinner from '@/@okmenu/components/utils/FetchingDataSpinner'

export default {
  name: 'AnnouncementModal',
  components: {
    FetchingDataSpinner, OkModal, OkVideoPlayer, BSpinner, BButton,
  },
  mixins: [LocalizationMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    announcement: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fetchedAnnouncement: null,
      loading: false,
      dismissing: false,
      accepting: false,
      error: null,
    }
  },
  computed: {
    computedAnnouncement() {
      return this.fetchedAnnouncement ?? this.announcement ?? {}
    },
  },
  watch: {
    value(show) {
      if (show) {
        if (this.id) {
          this.getAnnouncement()
        } else {
          this.fetchedAnnouncement = null
          this.playVideo()
        }
      }
    },
  },
  mounted() {
    this.playVideo()
  },
  methods: {
    playVideo() {
      setTimeout(() => {
        const video = document.getElementById('ok-video-element')
        if (video?.play) {
          video.play()
        }
      }, 600)
    },
    handleClose(dismissed) {
      this.dismissing = dismissed
      this.accepting = !dismissed
      AnnouncementsAPI.read(this.computedAnnouncement.id, dismissed)
        .finally(() => {
          this.$store.commit('auth/UPDATE_USER', { unreadAnnouncement: null })
          if (this.computedAnnouncement.url && !dismissed) {
            if (this.computedAnnouncement.url.includes('http')) {
              window.open(this.computedAnnouncement.url, '_blank')
            } else {
              this.$router.push(this.computedAnnouncement.url)
            }
          }
          this.$emit('input', false)
          this.dismissing = false
          this.accepting = false
        })
    },
    getAnnouncement() {
      this.loading = true
      this.error = null

      AnnouncementsAPI.show(this.id)
        .then(announcement => { this.fetchedAnnouncement = announcement; this.playVideo() })
        .catch(e => { this.error = e })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss">
.announcement-modal {
  .ok-modal-title {
    font-size: 18px!important;
  }

  .announcement-video {
    max-height: 320px;
    text-align: center;
  }

  .announcement-media-container {
    text-align: center;

    & > img {
      max-height: 320px;
    }
  }
}
</style>
